/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 * @flow
 */

import Banner from 'components/Banner';
import Container from 'components/Container';
import HeaderLink from './HeaderLink';
import {Link} from 'gatsby';
import React from 'react';
import {colors, fonts, media} from 'theme';
import {version} from 'site-constants';
import ExternalLinkSvg from 'templates/components/ExternalLinkSvg';
import DocSearch from './DocSearch';
import SiteConfig from 'site';

// $FlowFixMe
import navHeader from '../../../content/headerNav.yml';

import logoSvg from 'icons/logo.svg';

const ContainerWrapper = ({children}) => (
  <div
    css={{
      backgroundColor: 'hsl(222, 14%, 10%)',
    }}>
    {children}
  </div>
);

const Header = ({location}: {location: Location}) => (
  <header
    css={{
      backgroundColor: colors.darker,
      color: colors.white,
      position: 'fixed',
      zIndex: 4,
      width: '100%',
      top: 0,
      left: 0,
      '@media print': {
        display: 'none',
      },
    }}>
    <ContainerWrapper>
      <Container>
        <div style={{position: 'relative'}}>
          <Banner />
        </div>
      </Container>
    </ContainerWrapper>
    <Container>
      <div
        css={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          height: 60,
          [media.between('small', 'large')]: {
            height: 50,
          },
          [media.lessThan('small')]: {
            height: 40,
          },
        }}>
          <span className="menu-icon" onClick={()=>window.document.querySelector('[role="button"][tabindex="0"]').click()}
              css={{
                display: 'none',
                [media.lessThan('medium')]: {
                  display: 'block',
                },
              }}>
              <svg css={{transform: 'scale(2.3) translateX(2px)'}} width="12px" id="Layer_1" version="1.1" viewBox="0 0 32 32"><path fill="#ffffff" d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"/></svg>
            </span>
        <Link
          css={{
            display: 'flex',
            marginRight: 10,
            height: '100%',
            alignItems: 'center',
            color: colors.brand,

            ':focus': {
              outline: 0,
              color: colors.white,
            },

            [media.greaterThan('small')]: {
              width: 'calc(100% / 6)',
            },
            [media.lessThan('small')]: {
              flex: '0 0 auto',
            },
          }}
          to="/">
          <span
            css={{
              color: 'inherit',
              marginLeft: 10,
              fontWeight: 700,
              fontSize: 20,
              lineHeight: '20px',
              [media.lessThan('large')]: {
                fontSize: 16,
                marginTop: 1,
              },
              [media.lessThan('small')]: {
                // Visually hidden
                position: 'absolute',
                overflow: 'hidden',
                clip: 'rect(0 0 0 0)',
                height: 1,
                width: 1,
                margin: -1,
                padding: 0,
                border: 0,
              },
            }}>
             {process.env.GATSBY_logoText || SiteConfig.logoText}
          </span>
          <img src="/images/logo_small_gray.png" alt="" height="20" />
        </Link>

        <nav
          css={{
            flex: '1',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
            overflowX: 'auto',
            overflowY: 'hidden',
            WebkitOverflowScrolling: 'touch',
            height: '100%',

            // Hide horizontal scrollbar
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '::-webkit-scrollbar': {
              display: 'none',
            },

            [media.size('xsmall')]: {
              flexGrow: '1',
              width: 'auto',
            },
            [media.greaterThan('xlarge')]: {
              width: null,
            },
            [media.lessThan('small')]: {
              maskImage:
                'linear-gradient(to right, transparent, black 20px, black 90%, transparent)',
            },
          }}>
          {navHeader.items.map(link => (
            <HeaderLink
              key={link.title}
              isActive={location.pathname.includes(link.activeSelector)}
              title={link.title}
              to={link.to}
            />
          ))}
        </nav>

        <DocSearch />

        <div
          css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: 'auto',

            //[media.lessThan('medium')]: {
            //width: 'auto',
            //},
            //[media.greaterThan('large')]: {
            //width: 'calc(100% / 4)',
            //},
          }}>
          <Link
            css={{
              display: 'flex',
              alignItems: 'center',
              padding: '5px 10px',
              whiteSpace: 'nowrap',
              ...fonts.small,

              ':hover': {
                color: colors.brand,
              },

              ':focus': {
                outline: 0,
                backgroundColor: colors.lighter,
                borderRadius: 15,
              },
            }}
            to="/community/contact-us.html">
            {' '}
            <span
              css={{
                marginRight: '0.5rem',

                [media.lessThan('medium')]: {
                  display: 'none',
                },
              }}>
              اتصل بنا
            </span>
            <span
              css={{
                display: 'none',
                [media.lessThan('medium')]: {
                  display: 'block',
                },
              }}>
              <svg version="1.1" x="0px" y="0px"
                  viewBox="0 0 181.352 181.352" height="20px">
                <g>
                  <g>
                    <g>
                      <path style={{fill:"#ffffff"}} d="M169.393,167.37l-14.919,9.848c-9.604,6.614-50.531,14.049-106.211-53.404
                        C-5.415,58.873,9.934,22.86,17.134,14.555L29.523,1.678c2.921-2.491,7.328-2.198,9.839,0.811l32.583,38.543l0.02,0.02
                        c2.384,2.824,2.306,7.22-0.83,9.868v0.029l-14.44,10.415c-5.716,5.667-0.733,14.587,5.11,23.204l27.786,32.808
                        c12.926,12.477,20.009,18.241,26.194,14.118l12.008-13.395c2.941-2.472,7.328-2.169,9.839,0.821l32.603,38.543v0.02
                        C172.607,160.316,172.519,164.703,169.393,167.37z"/>
                    </g>
                  </g>
                </g>
                </svg>
            </span>
          </Link>
        </div>
      </div>
    </Container>
  </header>
);

export default Header;
